import { StrictBase } from '@wilson/base';
import type { OrganizationalUnit } from '../organizational-units/organizationalUnit';

export interface ShiftSetting extends StrictBase {
  organizationalUnitId: OrganizationalUnit['id'];
  shiftDrawerMode: ShiftDrawerMode;
}

export enum ShiftDrawerMode {
  Simple = 'simple',
  Detailed = 'detailed',
}
